import React from 'react';

import { Anchor } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import { useIntl } from 'react-intl';

import styles from '@styles/SingleBoat/overview_anchor.module.scss';

type Props = {
  details: {
    title: string;
    link: string;
    menu: {
      title: string;
      link: string;
      subMenu: {
        key: string | JSX.Element;
        value: string | number | boolean | JSX.Element;
      }[];
    }[];
  }[];
  jumbotronHeight: number;
};

const OverviewAnchor: React.FC<Props> = ({ details, jumbotronHeight }) => {
  const { formatMessage } = useIntl();
  const f = (id: string): string => formatMessage({ id });

  const { Link } = Anchor;

  const menu = details.map((item, index) => ({
    title: item.title,
    link: item.link,
    subMenu: details[index].menu.map((subItem) => ({
      title: subItem.title,
      link: subItem.link,
    })),
  }));

  return (
    <Anchor affix={false} className={styles.container} targetOffset={jumbotronHeight}>
      <h3 className={styles.container__title}>{f('single_boat.anchor.title')}</h3>

      {menu.map((item) => {
        const { title, link, subMenu } = item;

        return (
          <Link
            href={`#${link}`}
            title={
              <span>
                <ArrowRightOutlined /> {title}
              </span>
            }
            key={item.title}
            className={styles.container__menu__item}
          >
            {subMenu.map((subItem) => (
              <Link
                href={`#${subItem.link}`}
                title={subItem.title}
                key={subItem.link}
                className={styles.container__sub_menu__item}
              />
            ))}
          </Link>
        );
      })}
    </Anchor>
  );
};

export default OverviewAnchor;
